import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { CurrencyPipe, Location } from "@angular/common";
import { MatSnackBar } from "@angular/material/snack-bar";
import { takeUntil } from "rxjs/operators";
import { fuseAnimations } from "@fuse/animations";
import { AuthenticationService } from "app/helpers/authentication.service";
import { Router } from "@angular/router";
import { ToolbarService } from 'app/layout/components/toolbar/toolbar.service';
import { RegrasLimiteDespesaViagemDTO } from "../models/regras-limite-despesa-viagem.model";
import { RegrasLimiteDespesaViagemService } from "../services/regras-limite-despesa-viagem.service";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfirmDeleteComponent } from "app/shared/confirm-delete/confirm-delete.component";
import { AddVinculoFormComponent } from "../add-vinculo-form/add-vinculo-form.component";
import { EnumStatusCadastroBase, EnumTipoCadastroVinculo, EnumtoArray } from "app/shared/enum.service";
import { GrupoUsuariosService } from 'app/main/a2w/supervisor/restricoes-permissoes/grupo-usuarios/grupo-usuarios.service';
import { TiposDespesaService } from "../../tipos-despesas/services/tipos-despesa.service";
import { TiposPagamentoService } from "../../tipos-pagamentos/services/tipos-pagamento.service";
import { RegrasLimiteDespesasViagensService } from 'app/main/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesa-viagem/services/regras-limite-despesas-viagens.service';
import { Functions } from "app/helpers/functions";
import { MatSnackBarConfigComponent } from "app/shared/matSnackBarConfig/matSnackBarConfig.component";
import { UsuariosService } from "app/main/a2w/supervisor/restricoes-permissoes/usuario/usuarios.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { VinculoAgrupado } from "../models/vinculo-agrupado.interface";


@Component({
    selector: 'app-regras-limite-despesa-viagem',
    templateUrl: './regras-limite-despesa-viagem.component.html',
    styleUrls: ['./regras-limite-despesa-viagem.component.scss'], 
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class RegrasLimiteDespesaViagemComponent implements OnInit {

    isChecked: boolean = false;
    regraLimite: RegrasLimiteDespesaViagemDTO;
    pageType: string;
    regraLimiteForm: UntypedFormGroup;
    edit: boolean;
    dialogRef: any;
    confirmDeleteDialogRef: MatDialogRef<ConfirmDeleteComponent>;

    private _unsubscribeAll: Subject<any>;
    disabledVinculo: boolean = false;
    enumStatusCadastroBase: any[] = [];
    listaEmpresas: any;
    listaTiposPagamentos: any[] = [];
    listaGruposUsuarios: any[] = [];
    listaUsuarios: any[] = [];
    listaTiposDespesas: any[] = [];
    listaRegrasLimiteDespesaViagem: RegrasLimiteDespesaViagemDTO[] = [];
    regras: Regras[] = [];

    matSnackBarConf: any;

    vinculos: any = [];
    isLoadingButton: boolean = false;
    isLoadingRequest: boolean = false;

    constructor(
        private _tiposPagamentosService: TiposPagamentoService,
        private _regrasLimiteDespesaViagemService: RegrasLimiteDespesaViagemService,
        private _regrasLimiteDespesasViagensService: RegrasLimiteDespesasViagensService,
        private _formBuilder: UntypedFormBuilder,
        private _toolbarService: ToolbarService,
        private currencyPipe: CurrencyPipe,
        private route: Router,
        private _matSnackBar: MatSnackBar,
        private _matDialog: MatDialog,
        private _tiposDespesas: TiposDespesaService,
        private _gruposService: GrupoUsuariosService,
        private authenticationService: AuthenticationService,
        private _functions: Functions,
        private _fuseProgressBarService: FuseProgressBarService,
    ) {

        this._toolbarService.origem = "Painel TI » Cadastros » Despesas de Viagens";
        this._toolbarService.pagina = "Regra e Limite";
        this.regraLimite = new RegrasLimiteDespesaViagemDTO();
        this._unsubscribeAll = new Subject();
        this.matSnackBarConf = new MatSnackBarConfigComponent();

    }

    ngOnInit() {

        this.loadEnumStatusCadastroBase();

        // Inscrevo para atualizar o banco sobre alterações
        this._regrasLimiteDespesaViagemService.onDataChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(async result => {
                if (result) {
                    if (this.authenticationService.currentUserValue.accountId != result.accountId) {
                        this.route.navigate(["/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesas-viagens"]);
                    } else {
                        this.regraLimite = new RegrasLimiteDespesaViagemDTO(result);
                        
                        
                        this.pageType = "edit";
                        this.edit = true;
                        this.isChecked = this.regraLimite.statusCadastro == 0 ? false : true;
                    }
                } else {
                    this.pageType = "new";
                    this.regraLimite = new RegrasLimiteDespesaViagemDTO();
                    this.regraLimite.vinculosLimiteDespesaViagens = [];
                    this.regraLimite.statusCadastro = EnumStatusCadastroBase.Ativo;
                    this.edit = false;
                    this.isChecked = true;

                }

                this.regraLimiteForm = this.createRegraLimiteForm();
                await this.loadVinculos(this.regraLimite.vinculosLimiteDespesaViagens);
            });

            this.regraLimiteForm.get('isChecked').valueChanges
            .subscribe((response: any) => {

                if (response != null) {
                    if (response == true) {
                        this.isChecked = true;
                        this.regraLimiteForm.get('statusCadastro').setValue(1);
                    } else {
                        this.isChecked = false;
                        this.regraLimiteForm.get('statusCadastro').setValue(0);
                    }
                }
            });
    }

    ngOnDestroy(): void {
        // Unsubscribe para todos subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    loadEnumStatusCadastroBase() {

        this.enumStatusCadastroBase = EnumtoArray(EnumStatusCadastroBase);

    }

    createRegraLimiteForm(): UntypedFormGroup {
        return this._formBuilder.group({

            id: [this.regraLimite.id],
            statusCadastro: [this.regraLimite.statusCadastro],
            codigoRegra: [this.regraLimite.codigoRegra],
            valorRegra: [this.regraLimite.valorRegra],
            vinculosLimiteDespesaViagens: [this.regraLimite.vinculosLimiteDespesaViagens, (Validators.minLength(1))],
            isChecked: [this.regraLimite.statusCadastro == 0 ? false : true],
            calcularReembolsoAuto: [this.regraLimite.calcularReembolsoAuto],
            limiteDiario: [this.regraLimite.limiteDiario]

        });
    }

    updateRegraLimite() {

        const data = this.regraLimiteForm.getRawValue();
        const id = data.id;
        delete data.id;
        delete data.isChecked;

        if(data.valorRegra <= 0){
            this._matSnackBar.open("O valor da regra deve ser maior que zero!", "OK", this.matSnackBarConf.returnMatSnackBarConfig("warning"));
            return;
        }
        if(this._functions.isUndefinedNullEmptyLength((data.vinculosLimiteDespesaViagens.filter(x => x.tipoVinculo == EnumTipoCadastroVinculo["Tipo de Despesa"])), true)){
            for(let item of data.vinculosLimiteDespesaViagens){
                delete item.dataLancamento;
                delete item.dataModificacao;
                delete item.regraLimiteDespesaViagemId;
                delete item.guidId;
            }
            this._fuseProgressBarService.show();
            this.isLoadingRequest = true;
            this._regrasLimiteDespesaViagemService
                .updateById(data, id)
                .then(() => {
                    this._regrasLimiteDespesaViagemService.onDataChanged.next(data);

                    this._matSnackBar.open(
                        "Regra de limite atualizada com sucesso!",
                        "OK",
                        this.matSnackBarConf.returnMatSnackBarConfig("info")
                    );

                    this.route.navigate([
                        "/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesas-viagens"
                    ]);
                    this._fuseProgressBarService.hide();
                    this.isLoadingRequest = false;
                })
                .catch(error => {
                    const mensagens = Array.isArray(error.error?.message)
                        ? error.error.message.join("\n")
                        : error.error?.message || "Erro desconhecido.";

                    this._matSnackBar.open(
                        "Erro ao atualizar regra de limite. " + mensagens,
                        "OK",
                        this.matSnackBarConf.returnMatSnackBarConfig("danger")
                    );
                    this._fuseProgressBarService.hide();
                    this.isLoadingRequest = false;
                });
        } else {
            this._matSnackBar.open("Não é permitido atualizar Regra de Limite sem vínculo com Tipo de Despesa.", "OK", this.matSnackBarConf.returnMatSnackBarConfig("warning"));
        }

    }

    addRegraLimite(): void {

        const data = this.regraLimiteForm.getRawValue();
        delete data.id;
        delete data.isChecked;   
        
        if(data.valorRegra <= 0){
            this._matSnackBar.open("O valor da regra deve ser maior que zero!", "OK", this.matSnackBarConf.returnMatSnackBarConfig("warning"));
            return;
        }
        if(this._functions.isUndefinedNullEmptyLength((data.vinculosLimiteDespesaViagens.filter(x => x.tipoVinculo == EnumTipoCadastroVinculo["Tipo de Despesa"])), true)){
            for(let item of data.vinculosLimiteDespesaViagens){
                delete item.id;
            }
            this._fuseProgressBarService.show();
            this.isLoadingRequest = true;
            this._regrasLimiteDespesaViagemService.create(data)
                .then((resposta) => {
                    this._matSnackBar.open(
                        "Regra de limite adicionada com sucesso",
                        "OK",
                        this.matSnackBarConf.returnMatSnackBarConfig("info")
                    );
                    this.route.navigate([
                        "/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesas-viagens"
                    ]);
                    this._fuseProgressBarService.hide();
                    this.isLoadingRequest = false;
                })
                .catch(error => {
                    const mensagens = Array.isArray(error.error?.message)
                        ? error.error.message.join("\n")
                        : error.error?.message || "Erro desconhecido.";

                    this._matSnackBar.open(
                        "Erro ao atualizar regra de limite. " + mensagens,
                        "OK",
                        this.matSnackBarConf.returnMatSnackBarConfig("danger")
                    );
                    this._fuseProgressBarService.hide();
                    this.isLoadingRequest = false;
                });
        } else {
            this._matSnackBar.open("Não é permitido adicionar Regra de Limite sem vínculo com Tipo de Despesa.", "OK", this.matSnackBarConf.returnMatSnackBarConfig("info"));
        }
    }

    addVinculo() {

        this.dialogRef = this._matDialog.open(AddVinculoFormComponent, {
            panelClass: 'add-vinculo-form-dialog',
            data: {
                action: 'new',
                tipoVinculosUtilizados: this.vinculos.map(v => v.tipoVinculo),
                limiteDiario: this.regraLimiteForm.get('limiteDiario').value
            }
        });

        this.dialogRef.afterClosed()
            .subscribe((response: UntypedFormGroup) => {

                if (!response) {
                    return;
                }

                this.afterClose(response, null);

            });

    }

    async editVinculo(item){
        if (this.regraLimiteForm.get('limiteDiario').value) {
            
            
            this.dialogRef = this._matDialog.open(AddVinculoFormComponent, {
                panelClass: 'add-vinculo-form-dialog',
                data: {
                    action: 'edit',
                    tipoVinculosUtilizados: this.vinculos.map(v => v.tipoVinculo),
                    limiteDiario: this.regraLimiteForm.get('limiteDiario').value,
                    listReferencias: item.listReferencias,
                    tipoVinculo: item.tipoVinculo
                }
            });

            this.dialogRef.afterClosed()
                .subscribe((response: UntypedFormGroup) => {

                    if (!response) {
                        return;
                    }

                    this.afterClose(response, null);

                });
        }
    }

    async afterClose(response, vinculo) {
        const actionType: string = response[0];
        const formData = response[1];
        switch (actionType) {
            case 'new':
                for (const element2 of formData) {
                    this.regraLimite.vinculosLimiteDespesaViagens.push(element2);
                }
                
                this.regraLimiteForm.get('vinculosLimiteDespesaViagens').setValue(this.regraLimite.vinculosLimiteDespesaViagens);
                await this.loadVinculos(this.regraLimite.vinculosLimiteDespesaViagens);

            break;
            case 'edit':
                this.vinculos.find(x => x.tipoVinculo == formData[0].tipoVinculo).listReferencias = formData ?? [];
                this.regraLimite.vinculosLimiteDespesaViagens = [];
                for (const element of this.vinculos) {
                    for (const element2 of element.listReferencias) {
                        this.regraLimite.vinculosLimiteDespesaViagens.push(element2);
                    }
                }
                this.regraLimiteForm.get('vinculosLimiteDespesaViagens').setValue(this.regraLimite.vinculosLimiteDespesaViagens);
                await this.loadVinculos(this.regraLimite.vinculosLimiteDespesaViagens);
            break;
            case 'delete':
                this.deleteVinculo(vinculo);
            break;
        }

    }

    deleteVinculo(item: any) {
        this.confirmDeleteDialogRef = this._matDialog.open(ConfirmDeleteComponent, {
            disableClose: false
        });

        this.confirmDeleteDialogRef.componentInstance.confirmMessage = 'Confirmar exclusão do vínculo?';

        this.confirmDeleteDialogRef.afterClosed()
        .subscribe(async result => {
            
            if (result) {
                
                if(this.regraLimiteForm.get('limiteDiario').value){
                    this.vinculos.find(x => {
                        if(x.tipoVinculo == item.tipoVinculo){
                            x.listReferencias = []
                        }
                    })
                } else {
                    const index = this.vinculos.indexOf(item);

                    if (index >= 0) {
                        this.vinculos.splice(index, 1);
                    }
                }

                this.regraLimite.vinculosLimiteDespesaViagens = [];
                for (const element of this.vinculos) {
                    for (const element2 of element.listReferencias) {
                        this.regraLimite.vinculosLimiteDespesaViagens.push(element2);
                    }
                }
                this.regraLimiteForm.get('vinculosLimiteDespesaViagens').setValue(this.regraLimite.vinculosLimiteDespesaViagens);
                await this.loadVinculos(this.regraLimite.vinculosLimiteDespesaViagens);
            }
            this.confirmDeleteDialogRef = null;
            
            

        });
    }

    identify(index, item) {
        return item.id;
    }


    buscaNomeTipoVinculo(tipoVinculo) {
        return EnumTipoCadastroVinculo[tipoVinculo];
    }

    async loadVinculos(vinculos) {
        this._fuseProgressBarService.show();
        this.isLoadingButton = true;
        this.vinculos = [];

        const agrupados = vinculos.reduce((acc, item) => {
            if (!acc[item.tipoVinculo]) {
                acc[item.tipoVinculo] = {
                    guidId: item.guidId, 
                    tipoVinculo: item.tipoVinculo,
                    dataLancamento: item.dataLancamento,
                    dataModificacao: item.dataModificacao,
                    listReferencias: []
                } as VinculoAgrupado;
            }
            acc[item.tipoVinculo].listReferencias.push(item);
            return acc;
        }, {} as { [key: number]: VinculoAgrupado });

        for (const grupo of Object.values(agrupados) as VinculoAgrupado[]) {
            for (let vinc of grupo.listReferencias) {
                let descricao = "";

                switch (grupo.tipoVinculo) {
                    case EnumTipoCadastroVinculo["Tipo de Despesa"]: {
                        const res = await this._tiposDespesas.getById(vinc.tipoVinculoReferenciaId);
                        descricao = res?.descricaoCadastro ?? "";
                        break;
                    }

                    case EnumTipoCadastroVinculo["Tipo de Pagamento"]: {
                        const res = await this._tiposPagamentosService.getById(vinc.tipoVinculoReferenciaId);
                        descricao = res?.descricaoCadastro ?? "";
                        break;
                    }

                    case EnumTipoCadastroVinculo["Grupo de Usuário"]: {
                        if (!this.listaGruposUsuarios?.length) {
                            this.listaGruposUsuarios = await this._gruposService.listAll();
                        }
                        const grupoUsuario = this.listaGruposUsuarios.find(x => x.userGroupId == vinc.tipoVinculoReferenciaId);
                        descricao = grupoUsuario?.userGroupName ?? "";
                        break;
                    }
                }

                vinc.descricao = descricao;
            }

            this.vinculos.push(grupo);
        }

        this._fuseProgressBarService.hide();
        this.isLoadingButton = false;
        
    }

    retornaDescricaoVinculo(vinculo): string{  
        return vinculo.listReferencias.map(v => v.descricao).join(', ') || '';
    }


    desabilitaStatus(status) {

        let retorno = false;

        if (status == EnumStatusCadastroBase.Ativo || status == EnumStatusCadastroBase.Inativo) {
            retorno = true;
        }

        return retorno;
    }

    listaRegrasJaCadastradas() {
        this._regrasLimiteDespesasViagensService.getAll()
            .then(result => {
                this.geraListaRegrasJaCadastradas(result);
            });
    }

    geraListaRegrasJaCadastradas(listaRegrasLimiteDespesaViagem) {

        listaRegrasLimiteDespesaViagem.forEach(regra => {

            const provi = new Regras();
            provi.valor = regra.valorRegra;
            provi.regra = regra;

            regra.vinculosLimiteDespesaViagens.forEach(vinculo => {
                if (vinculo.tipoVinculo == EnumTipoCadastroVinculo["Tipo de Despesa"]) {
                    provi.despesa = vinculo.tipoVinculoReferenciaId;
                } else if (vinculo.tipoVinculo == EnumTipoCadastroVinculo["Tipo de Pagamento"]) {
                    provi.pagto = vinculo.tipoVinculoReferenciaId;
                } else if (vinculo.tipoVinculo == EnumTipoCadastroVinculo["Grupo de Usuário"]) {
                    provi.grupo = vinculo.tipoVinculoReferenciaId;
                }
            });

            this.regras.push(provi);

        });

    }

    formatMoney(value) {
        const temp = `${value}`.replace(/\,/g, "");
        this.currencyPipe = new CurrencyPipe('pt-BR');
        return this.currencyPipe.transform(temp, 'BRL');//.replace("$", "");
    }


    qtdeRegra(regra) {

        let qtde = 0;
        if (regra.despesa) {
            qtde++;
        }
        if (regra.pagto) {
            qtde++;
        }
        if (regra.grupo) {
            qtde++;
        }
        return qtde;
    }

}

export class Regras {
    valor: number;
    grupo: string;
    despesa: string;
    pagto: string;
    regra: RegrasLimiteDespesaViagemDTO
}


